export default {
    path: '/user-details',
    component: () => import('../views/Global/GenericDashboardView.vue'),
    meta: {
        private: true,
        title: 'USER_DETAILS',
    },
    children: [
        {
            path: 'my-account',
            name: 'my-account',
            component: () => import('@/components/UserAccount/views/AccountBlock.vue'),
            meta: {
                title: 'MY_ACCOUNT',
            },
        },
        {
            path: 'employees',
            name: 'employees',
            component: () => import('@/components/UserAccount/views/EmployeesBlock.vue'),
            meta: {
                title: 'EMPLOYEES',
            },
        },
        {
            path: 'organization',
            name: 'user-organization',
            component: () => import('@/components/UserAccount/views/OrganizationBlock.vue'),
            meta: {
                title: 'ORGANIZATION',
            },
        },
        {
            path: 'contacts',
            name: 'user-contacts',
            component: () => import('@/components/UserAccount/views/ContactsBlock.vue'),
            meta: {
                title: 'CONTACTS',
            },
        },
        {
            path: 'subscriptions',
            name: 'user-subscriptions',
            component: () => import('@/components/UserAccount/views/SubscriptionsBlock.vue'),
            meta: {
                title: 'SUBSCRIPTIONS',
            },
        },
        {
            path: 'referral',
            name: 'user-referral',
            component: () => import('@/components/UserAccount/views/Referrals.vue'),
            meta: {
                title: 'REFERRAL',
            },
        },
        {
            path: 'process-labels',
            name: 'user-process-labels',
            component: () => import('@/components/UserAccount/views/ProcessLabels.vue'),
            meta: {
                title: 'PROCESS_LABELS',
            },
        },
        {
            path: ':(.*)',
            redirect: { name: 'my-account' },
        },
    ],
};
